<h1 mat-dialog-title>
    A operação não possui um tipo de título
</h1>

<mat-dialog-content>
    <mat-card-subtitle>
        A operação vinculada a esse orçamento não possui um tipo de título.
        Selecione um tipo de título para que os títulos financeiros sejam criados.
    </mat-card-subtitle>

    <mat-form-field class="col-6 justify-content-start">
        <mat-label>Tipo de título</mat-label>
        <mat-select [(ngModel)]="selectedTitle">
            <mat-option *ngFor="let title of titleTypes"
                        [value]="title._id">
                {{ title.description }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button aria-label="cancel"
            mat-raised-button
            color="accent"
            type="button"
            (click)="close(false)">
        {{ 'ACTION.SHARED.CANCEL' | translate }}
    </button>
    <button type="button"
            aria-label="save"
            mat-raised-button
            color="primary"
            [disabled]="!selectedTitle"
            (click)="close(true)">
        {{ 'ACTION.SHARED.SAVE_CHANGES' | translate }}
    </button>
</mat-dialog-actions>
